import VAlert from './VAlert'

export default {
  VAlert
}



// WEBPACK FOOTER //
// ./src/components/alerts/index.js